import React from 'react';
/*
import logo from './logo.svg';
import { Counter } from "./features/counter/Counter";
*/
import { VeggieMeter } from "./features/veggiemeter/VeggieMeter";
import './App.css';

function App() {
  return (
    <div className="App">
      <VeggieMeter />
    </div>
  );
}

export default App;
